import React from 'react';

const MongoDB_count = () => {
  return (
    <div>
      <h1>MongoDB_count Component</h1>
      <p>This is the MongoDB_count page.</p>
    </div>
  );
};

export default MongoDB_count;
